module.exports = __webpack_public_path__ + "img/jhrwm.930eb3f6.jpg";